import { getLocale } from 'next-intl/server';

import { convertUrlSegmentToLanguageName } from '@shared/utils';

import { getCustomerOptimizelyRolesPageFilter } from '../../get-customer-optimizely-roles';

export const getCommonSearchQueryFilters = async () => {
  const localeURLSegment = await getLocale();
  const languageName = convertUrlSegmentToLanguageName(localeURLSegment);

  return {
    ExcludeFromSearch: {
      notEq: true,
    },
    Language: {
      Name: {
        eq: languageName,
      },
    },
    Status: {
      eq: 'Published',
    },
    ...(await getCustomerOptimizelyRolesPageFilter()).where,
  };
};
